import ReactGA from 'react-ga4';
import Clarity from '@microsoft/clarity';
import { captureException } from '@sentry/react';
import { isProductionApp } from '../../Services/environment';

const trackActivity = (category, action, additionalData = {}) => {
    // Outside production the SDKs were never initialised, so calling them would
    // only throw into captureException.
    if (!isProductionApp()) {
        return;
    }

    try {
        ReactGA.event({
            category,
            action,
            ...additionalData,
        });
    } catch (err) {
        captureException(err);
    }

    try {
        Clarity.event(`${category}_${action}`, additionalData);
    } catch (err) {
        captureException(err);
    }
};

export default trackActivity;
